module.exports = __webpack_public_path__ + "static/img/14000691.0e3a08ce.png";